import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { FC } from 'react';
import { HomeConnected } from './container';
import { HomeVersionProps } from './HomeVersion.types';
import { HomeV2 } from './v2';

export const HomeVersion: FC<HomeVersionProps> = ({ property, language, id }) => {
  const isV2 = useFeatureIsOn('feature.ecom2');

  if (isV2) return <HomeV2 property={property} language={language} />;
  return <HomeConnected id={id} language={language} />;
};
